export default "__VITE_ASSET__CTlaPEjq__"